module.exports = __webpack_public_path__ + "img/cover-gospooky.b8d9d05f.jpg";